module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4T6WTMS9EQRSFv5Mo6LUSEoVklTqrV9ApNX6BVasEyRaKVSnpKHUiShIFhUIhUSBR6vyAIze5m+xjnt3HNJPMzPnmnHtnZLsFnAALNBtPwLps3wE3wGEzPZvAcgAMzEh6bQKwPQs8/wcwDbwUAbbngCtgVdJDyZntKgAYB46AHeAUOAP2gevcG+R0gcuKA+A9hWtAT9JWKGy3gbFvLqIDcWE1gu04uCLpfFhBf0SILuTidor3JL3VgeoAkfcjRZOSlmwv1kSYKEX4jMcBCLgApoDbkYqYEXaBTjo4kBQdKY5ihKz6fMySHn8rZC1gWPX7+4OA/mfqjSrOcxG1HU85LB//4TvfAxtfKYSm1i1MrzMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/zsrwActive.png
// module id = /pP0
// module chunks = 96